import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'È un prodotto fisico o digitale?',
  a: 'RUNNING COACH PRO™ è un prodotto digitale in formato PDF ad alta qualità. Potrai scaricarlo immediatamente dopo l\'acquisto e utilizzarlo da computer, tablet o smartphone.'
}, {
  q: 'È adatto anche ai nuovi allenatori?',
  a: 'Sì. Il sistema è stato progettato sia per coach alle prime esperienze sia per professionisti che desiderano risparmiare tempo, lavorare con maggiore organizzazione e offrire un servizio ancora più professionale.'
}, {
  q: 'Posso adattare i programmi ai miei atleti?',
  a: 'Assolutamente sì. Tutti i programmi, le sessioni, gli esercizi e i documenti possono essere personalizzati in base al livello, agli obiettivi e alle caratteristiche di ogni runner.'
}, {
  q: 'Dopo quanto tempo inizierò a risparmiare tempo?',
  a: 'La maggior parte dei coach inizia già dalla prima settimana a preparare programmi e allenamenti molto più velocemente, lavorando con maggiore organizzazione ed efficienza.'
}, {
  q: 'Quali distanze sono coperte dai programmi?',
  a: 'Sono inclusi programmi completi per 5K, 10K, Mezza Maratona, Maratona e Trail Running, con versioni per principianti, intermedi e avanzati e durate differenti.'
}, {
  q: 'Funziona per atleti individuali e gruppi di corsa?',
  a: 'Sì. Programmi e sessioni includono varianti per il lavoro individuale, per piccoli gruppi e per gruppi numerosi, con adattamenti immediati quando i livelli sono differenti.'
}, {
  q: 'Include anche il lavoro di forza e la prevenzione degli infortuni?',
  a: 'Sì. Il modulo Strength & Performance Systems™ e il bonus dedicato includono routine per palestra, corpo libero ed elastici, con protocolli di prevenzione già integrabili in qualsiasi pianificazione.'
}, {
  q: 'Posso stampare le schede, i planner e i test?',
  a: 'Sì. Programmi, schede di valutazione, registri dei carichi, checklist e planner sono progettati per essere stampati e usati direttamente al campo, in palestra o in studio.'
}, {
  q: 'È un pagamento unico o un abbonamento?',
  a: 'È un pagamento unico di 27€. Nessun costo ricorrente: accedi a tutti i 6 moduli e ai 5 bonus per sempre.'
}, {
  q: 'Come funziona il rimborso se non sono soddisfatto?',
  a: 'Ti basterà contattarci entro 14 giorni dall\'acquisto e riceverai il rimborso completo. Nessun rischio, nessuna domanda.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-6 px-4 sm:px-6 bg-cream" data-id="element-33" data-mp="2yms93xuh0ea3">
      <h2 className="text-lg sm:text-3xl font-heading font-extrabold text-center text-navy leading-tight uppercase mb-4" data-id="element-34" data-mp="2ypehu0t3kztw">
        Domande Frequenti
      </h2>

      <div className="flex flex-col gap-1.5 max-w-3xl mx-auto" data-id="element-35" data-mp="1n97ovl3dq87z">
        {faqs.map((faq, i) => {
        const isOpen = openIndex === i;
        return <div key={faq.q} className="bg-white border border-gold/40 rounded-lg overflow-hidden" data-id="element-36" data-mp="3utwr0jfnafbo" data-mpi={i}>
              <button onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="w-full px-3.5 py-2.5 text-left flex justify-between items-center gap-3 hover:bg-cream/70 transition-colors" data-id="element-37" data-mp="2r5jrnpqttj2">
                <span className="font-heading font-bold text-navy text-[12.5px] sm:text-base leading-snug" data-id="element-38" data-mp="heqofm29o0t3">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-4 h-4 text-gold-dark shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-39" data-mp="qfgesa8rcyzf" />
              </button>
              {isOpen && <p id={`faq-panel-${i}`} className="px-3.5 pb-2.5 text-anthracite text-[12.5px] sm:text-sm leading-relaxed" data-id="element-40" data-mp="2s8menhbz82nn">
                  {faq.a}
                </p>}
            </div>;
      })}
      </div>
    </section>;
}